export type CollectionLayout = 'default' | 'compact' | 'cover'

const STORAGE_KEY = 'tunetoss.collectionLayout'

export function readCollectionLayout(): CollectionLayout {
	try {
		const value = localStorage.getItem(STORAGE_KEY)
		return value === 'compact' || value === 'cover' ? value : 'default'
	} catch {
		return 'default'
	}
}

export function saveCollectionLayout(layout: CollectionLayout): void {
	try {
		localStorage.setItem(STORAGE_KEY, layout)
	} catch {
		// Keep the current view usable when device storage is unavailable.
	}
}

export function nextCollectionLayout(
	layout: CollectionLayout,
): CollectionLayout {
	return layout === 'default'
		? 'compact'
		: layout === 'compact'
			? 'cover'
			: 'default'
}
